import utcTime from "support/utcTime";

export default function (activityTracker, tokens, storage, previousUserStorage) {
	const tokenStorage = storage.crossTab("NexusAccess");
	const expStorage = storage.crossTab("NexusExpiration");
	const usernameStorage = storage.crossTab("NexusUsername");
	const sessionSwitchStorage = storage.crossTab("NexusSessionSwitch");

	function isTokenNotExpired() {
		const expiration = expStorage.getInt();
		return !!expiration && expiration > utcTime.now();
	}

	function hasExpiredToken() {
		const accessToken = getAccessToken();
		const expiration = expStorage.getInt();
		return accessToken && expiration && expiration <= utcTime.now();
	}

	function isSessionExpired() {
		return !isSessionOn() || activityTracker.isSessionExpired();
	}

	function isSessionNotExpired() {
		return !isSessionExpired();
	}

	function getAccessToken() {
		return tokenStorage.get();
	}

	function isSessionOn() {
		return !!sessionSwitchStorage.getInt();
	}

	function sessionOn() {
		sessionSwitchStorage.set(1);
	}

	function getExpValue() {
		return expStorage.getInt();
	}

	this.login = (token) => {
		tokenStorage.set(token.raw);
		expStorage.set(token.payload.exp);
		usernameStorage.set(token.payload.sub);
		sessionOn();
	};

	this.logout = () => {
		previousUserStorage.store(usernameStorage.get());
		storage.clear();
	};

	this.isLogged = () => (
		isTokenNotExpired() && isSessionNotExpired()
	);

	this.isNotLogged = () => (
		!this.isLogged()
	);

	this.username = () => (
		usernameStorage.get()
	);

	this.usernameIsChangedAfterLogin = () => (
		previousUserStorage.hasDifferentUser(usernameStorage.get())
	);

	this.debugInfo = () => (
		`isLogged: ${this.isLogged()}, isTokenNotExpired: ${!hasExpiredToken()},
		isSessionNotExpired: ${isSessionNotExpired()},
		expValue: ${getExpValue()}, username: ${this.username()}, sessionSwitch: ${isSessionOn()}`
	);

	this.tokenWillExpireIn = (secs) => {
		const accessToken = getAccessToken();
		return tokens.willExpireIn(accessToken, secs);
	};
	this.hasExpiredToken = hasExpiredToken;
	this.isSessionExpired = isSessionExpired;
	this.isSessionNotExpired = isSessionNotExpired;
	this.getAccessToken = getAccessToken;
	this.getExpValue = getExpValue;
}
